/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
export const withStoryPageContent = async (Component, subPageType) => {
  const StoryComponent = await getStoryComponent(subPageType);
  const renderStoryPageContent = props => <StoryComponent {...props} />;
  const Comp = props => {
    return <Component renderStoryPageContent={renderStoryPageContent} {...props} />;
  };
  return Comp;
};

export const getStoryComponent = async subPageType => {
  /*
   * It is important here that we dynamically import the ENTIRE filepath without variables.
   * If the path is not specified as a single string, webpack cannot predict what the final
   * path will resolve to, and includes all JS from that relative path to the final bundle.
   * Which is what happened once and affected performance.
   */
  switch (subPageType) {
    case "text":
      return (await import(
        /* webpackChunkName: "StoryTemplateChunkText" */
        /* webpackPreload: true */ "../components/story-templates/text-story"
      )).default;
    case "live-blog":
      return (await import(
        /* webpackChunkName: "StoryTemplateChunkLiveBlog" */
        /* webpackPreload: true */ "../components/story-templates/live-blog"
      )).default;
    case "video":
      return (await import(
        /* webpackChunkName: "StoryTemplateChunkVideo" */
        /* webpackPreload: true */ "../components/story-templates/video-story"
      )).default;
    case "photo":
      return (await import(
        /* webpackChunkName: "StoryTemplateChunkPhoto" */
        /* webpackPreload: true */ "../components/story-templates/photo-story"
      )).default;
    case "visual-story":
      return (await import(
        /* webpackChunkName: "StoryTemplateChunkVisual" */
        /* webpackPreload: true */ "../components/story-templates/visual-story"
      )).default;
    case "listicle":
      return (await import(
        /* webpackChunkName: "StoryTemplateChunkListicle" */
        /* webpackPreload: true */ "../components/story-templates/listicle-story"
      )).default;
    case "other":
      return (await import(
        /* webpackChunkName: "StoryTemplateChunkOther" */
        /* webpackPreload: true */ "../components/story-templates/other"
      )).default;
    default:
      return (await import(
        /* webpackChunkName: "StoryTemplateChunkCustom" */
        /* webpackPreload: true */ "../components/story-templates/custom-story"
      )).default;
  }
};
